import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';

export interface StaffInviteFrom {
  from: string;
  replyTo: string;
}

export function useStaffInviteFrom(pageId: string) {
  const { token } = useAuth();
  return useQuery<StaffInviteFrom>({
    queryKey: ['staff-invite-from', pageId],
    queryFn: () => fetcher(`/scanner/${pageId}/staff-invite-from`, token),
    enabled: !!pageId,
    staleTime: 60 * 60 * 1000,
  });
}
